import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setDashboardIsHomepage from "@insite/client-framework/Store/Context/Handlers/SetDashboardIsHomepage";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import OrderRemainderData from "@TKCCP/Handler/TkccpOrderReminderHandler";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import { current } from "immer";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    customerNumber: state.context.session.billToId,
    dashboardIsHomepage: state.context.session.dashboardIsHomepage ?? undefined,
    orderToggle: getBillToState(state, state.context.session.billToId).value,
    orderReminderCheck: state.tKCCPData.orderRiminderDataStore.EmailReminderforOrders,
});

const mapDispatchToProps = {
    OrderRemainderData,
};

export interface MyAccountHomepageSelectorStyles {
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
}

export const myAccountHomepageSelectorStyles: MyAccountHomepageSelectorStyles = {
    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
};
OrderRemainderData;
const styles = myAccountHomepageSelectorStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OrderReminder = ({ customerNumber, OrderRemainderData, orderToggle, orderReminderCheck }: Props) => {
    const [isChecked, setIsCheckek] = useState(false);

    useEffect(() => {
        setIsCheckek(
            orderReminderCheck === undefined
                ? orderToggle?.properties["emailReminderforOrders"] === "True" ||
                      orderToggle?.properties["emailReminderforOrders"] === "true"
                : orderReminderCheck,
        );
    }, [
        orderToggle?.properties["emailReminderforOrders"] === "True" ||
            orderToggle?.properties["emailReminderforOrders"] === "true",
    ]);

    const dashboardIsHomepageChangeHandler = (event: React.SyntheticEvent<Element, Event>, value: boolean) => {
        if (customerNumber) {
            OrderRemainderData({ CustomerId: customerNumber, EmailReminderforOrders: value });
        }
        setIsCheckek(value);
    };

    return (
        <CheckboxGroup {...styles.checkboxGroup}>
            <Checkbox
                {...styles.checkbox}
                onChange={dashboardIsHomepageChangeHandler}
                checked={isChecked}
                data-test-selector="makeMyHomePageCheckbox"
            >
                {siteMessage("Order_reminder")}
            </Checkbox>
        </CheckboxGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderReminder),
    definition: {
        group: "My Account",
        displayName: "Order Reminder",
    },
};

export default widgetModule;
